import gql from 'graphql-tag';

/**
 * Get programme with result templates
 */
export const GET_PROGRAMME_WITH_TEMPLATES = gql`
  query GetProgramme($id: ID!) {
    getProgramme(id: $id) {
      id
      program_name
      prog_code
      degree
      type
      duration
      min_units
      department_id
      is_active
      resultTemplates {
        id
        name
        code
        grade_group {
          id
          name
          gradeBands {
            id
            grade
            minimum
            maximum
            point
            name
          }
        }
        columns {
          id
          label
          key
          type
          sequence
          is_visible
          calculation_function
          calculation_arguments
          school_assessment_type {
            id
            name
            max_score
          }
        }
      }
    }
  }
`;

/**
 * List programmes with result templates
 */
export const GET_PROGRAMMES_WITH_TEMPLATES = gql`
  query ListSchoolProgrammesWithTemplates(
    $first: Int! = 10
    $page: Int
    $filter: programmeFilterInput
    $academic_calendar_id: ID
  ) {
    listSchoolProgrammes(filter: $filter, first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        program_name
        prog_code
        degree
        type
        duration
        min_units
        department_id
        is_active
        resultTemplates {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * Get student result for tertiary (with GPA/CGPA)
 */
export const GET_STUDENT_RESULT_TERTIARY = gql`
  query GetStudentResultTertiary($student_id: ID!, $academic_calendar_id: ID!) {
    studentResult(student_id: $student_id, academic_calendar_id: $academic_calendar_id) {
      status
      summary
      data

      headers {
        label
        key
        type
        is_visible
      }

      student {
        id
        surname
        firstName: first_name
        other_name
        matric_no
        email
        phone
        photo
      }

      programme {
        id
        program_name
        prog_code
        degree
      }

      academic_calendar {
        id
        session {
          id
          name
        }
        termStructure {
          id
          name
        }
      }

      template {
        id
        name
        code
        grade_group {
          id
          name
        }
      }

      result_feedbacks {
        id
        result_template_feedback {
          id
          label
          code
          input_type
          rating_max
        }
        comment
        rating
        rating_label
      }
    }
  }
`;

/**
 * Get student's transferable courses
 */
export const GET_STUDENT_TRANSFERABLE_COURSES = gql`
  query GetStudentCourseRegistrations($studentId: Int!) {
    getCourseRegistrationsForStudent(
      student_id: $studentId
    ) {
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      coursesRegistered {
          programme_module_id
          module_name
          module_sequence
        id
        course_id
        course_status
        is_transferred
        accepted_for_programme_id
        accepted_at
        acceptedForProgramme {
          id
          program_name
        }
        acceptedByUser {
          id
          name
        }
        course {
          id
          course_code
          course_title
          unit
        }
        scores {
          id
          score
          school_assessment_type_id
          approval_status
        }
      }
    }
  }
`;
